// ======================================================================
// File Name       : SystemHintDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Col } from 'react-bootstrap';
import { SHOW_HINT_MODAL } from '../../constants/actionTypes/modal';
import { MODAL_SIZE, VIDEO_STEP1, VIDEO_STEP2, VIDEO_STEP3 } from '../../constants';
import courseRegist from '../../images/course-regist-off.png';
import libraryRegist from '../../images/library-24-off.png';
import courseRegistOn from '../../images/course-regist-on.png';
import libraryRegistOn from '../../images/library-24-on.png';

class SystemHintDialog extends React.Component {
  constructor(props) {
    super();
    this.state = {
      videoUrl: '',
      type: '',
      step1Click: true,
      step2Click: false,
      step3Click: false,
    };
    this.userRegistionGuide = this.userRegistionGuide.bind(this);
    this.contentRegistionGuide = this.contentRegistionGuide.bind(this);
    this.courseRegistionGuide = this.courseRegistionGuide.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.setState({
      step1Click: false,
      step2Click: false,
      step3Click: false,
    }, () => {
      window.close();
    });
  }
  userRegistionGuide() {
    this.setState({ step1Click: true, step2Click: false, step3Click: false });
    const video = document.getElementById('tutorialVideo');
    video.src = VIDEO_STEP1;
    video.load();
  }

  contentRegistionGuide() {
    this.setState({ step1Click: false, step2Click: true, step3Click: false });
    const video = document.getElementById('tutorialVideo');
    video.src = VIDEO_STEP2;
    video.load();
  }

  courseRegistionGuide() {
    this.setState({ step1Click: false, step2Click: false, step3Click: true });
    const video = document.getElementById('tutorialVideo');
    video.src = VIDEO_STEP3;
    video.load();
  }

  componentDidMount() {
    const video = document.getElementById('tutorialVideo');
    if (video) {
      video.src = VIDEO_STEP1;
      video.load();
    }
  }
  render() {
    const style = {
      margin: 'auto',
      width: '1000px',
    };
    

    let titleText = 'コンテンツを登録し配信するまでの手順を確認しましょう。';
    let titleDescription =
      '動画の手順に沿って操作を進めることで、コンテンツ配信までの流れを確認することができます。';
    if (this.state.step1Click) {
      titleText = 'STEP1　ユーザーの登録';
      titleDescription = ['本画面にて、サービス利用開始までのユーザーやコンテンツの登録手順を紹介します。', <br />,
        'サービス利用者となるユーザーの登録手順を確認しましょう。'];
    }
    if (this.state.step2Click) {
      titleText = 'STEP2　コンテンツの登録';
      titleDescription =
        '配信するコンテンツの登録手順を確認しましょう。本サンプルではドキュメントの登録を行います。';
    }
    if (this.state.step3Click) {
      titleText = 'STEP3　コースの登録・紐付け';
      titleDescription = `登録したコンテンツをコースに紐付けてユーザーに配信してみましょう。
        以上でコンテンツの配信手順は終了です。マニュアルを参考にさまざまな機能を利用してみましょう。`;
    }
    return (
      <div className="hint" style={style}>
        <Col sm={12}>
          <div className="demo demo9">
            <div className="hding ">
              {titleText}
            </div>
          </div>
        </Col>
        <Col sm={11} className="min-height-2line margin-top-20 margin-bottom-20">
          <div className="padding-left-10 margin-left-50">
            <span>{titleDescription}</span>
          </div>
        </Col>
        <Col sm={11} className="margin-left-50 padding-right-clear">
          <Col
            sm={3}
            className={this.state.step1Click ? 'step-default active' : 'step-default box-shadow'}
            onClick={this.userRegistionGuide}
          >
            <Col sm={6} className="padding-right-clear margin-top-20" style={{ display: 'flex' }}>
              <div
                className="padding-5 btn-demo step-button-inside"
              >
                STEP1
              </div>
              <div className="bi bi-person-fill margin-left-10 margin-top-10 icon-text-white" />
            </Col>
            <Col sm={5} className="padding-clear text-center video-text-step1 margin-top-20 icon-text-white">
              <p className="bold">ユーザーの登録</p>
            </Col>
          </Col>
          <Col sm={1} className="text-center padding-left-clear">
            <span className="bi bi-caret-right-fill margin-top-45" />
          </Col>

          <Col
            sm={3}
            className={this.state.step2Click ? 'step-default active' : 'step-default box-shadow'}
            onClick={this.contentRegistionGuide}
          >
            <Col sm={6} className="padding-right-clear margin-top-20 " style={{ display: 'flex' }}>
              <div
                className="padding-5 btn-demo step-button-inside"
              >
                STEP2
              </div>
              <img src={!this.state.step2Click ? libraryRegist : libraryRegistOn} alt="content" className="margin-left-10" />
            </Col>
            <Col sm={5} className="padding-clear text-center video-text margin-top-20 padding-right-10 margin-left-10 icon-text-white">
              <p className="bold">コンテンツの <br /> 登録</p>
            </Col>
          </Col>

          <Col sm={1} className="text-center padding-left-clear">
            <span className="bi bi-caret-right-fill margin-top-45" />
          </Col>

          <Col
            sm={3}
            className={this.state.step3Click ? 'step-default active' : 'step-default box-shadow'}
            onClick={this.courseRegistionGuide}
          >
            <Col sm={6} className="padding-right-clear margin-top-20 " style={{ display: 'flex' }}>
              <div
                className="padding-5 btn-demo step-button-inside"
              >
                STEP3
              </div>
              <img src={!this.state.step3Click ? courseRegist : courseRegistOn} alt="content" className="margin-left-10" />
            </Col>
            <Col sm={5} className="padding-clear text-center video-text margin-top-20  padding-right-10 margin-left-10 icon-text-white">
              <p className="bold">コースの <br /> 登録・紐付</p>
            </Col>
          </Col>
        </Col>

        <Col sm={12} className="text-center margin-top-30">
          <video id="tutorialVideo" className="hint-video-size" controls autoPlay>
            Your browser does not support HTML5 video.
          </video>
        </Col>
        <Col sm={12} className="text-center margin-top-30">
          <Button className="btn btn-primary" onClick={this.closeModal}> 閉じる </Button>
        </Col>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const { logined, authedUser } = state.authed;
  const { message } = state;
  return ({
    ...state,
    authedUser,
    logined,
    superUser: state.superUser,
    message,
  });
};
SystemHintDialog.defaultProps = { animation: true };
export default connect(mapStateToProps)(SystemHintDialog);
